export default function getFiltersValues(values: Record<string, unknown>) {
  return Object.entries(values).reduce((acc, [key, value]) => (value === null || value === undefined ? acc : { ...acc, [key]: value }), {});
}
